<template>
  <div class="framework">
    <CardRive
      v-for="(page, pageIndex) in pagesKeys"
      :key="page"
      :title="pagesTitles[pageIndex]"
      :class="`framework-card card-${pageIndex}`"
      :url="page"
      :style="{ '--back-color': `var(--framework-${page})` }"
    />
  </div>
</template>

<script setup>
import { computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import CardRive from "../atoms/CardRive.vue";

const i18n = useI18n();
const { tm } = useI18n();

const pagesKeys = computed(() =>
  Object.keys(tm("navigation")).filter((page) => !["home"].includes(page))
);

const pagesTitles = computed(() =>
  Object.values(tm("navigation")).filter((page) => !["Homepage"].includes(page))
);

watch(
  () => i18n.locale.value,
  () => {
    console.log(i18n.locale.value);
  }
);
</script>

<style lang="scss" scoped>
.framework {
  --rotate-offset: 30deg;
  --offset: -60px;
  //   margin-top: toRem(150);
  //   margin-left: toRem(110);

  width: toRem(450);
  height: toRem(450);
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.3);
  position: relative;
  top: 45%;
  transform: rotate(var(--rotate-offset)) translate(0, -50%);

  @media only screen and (max-width: 1370px) {
    --offset: -20px;
    width: toRem(350);
    height: toRem(350);
    aspect-ratio: 1;

    .framework-card {
      width: toRem(168);
    }
  }

  //   @media only screen and (min-height: 720px) {
  //     margin-top: toRem(150);
  //   }

  &-card {
    position: absolute;
    transform: rotate(calc(var(--rotate-offset) * -1));
    background-color: var(--back-color);

    &.card-0 {
      top: var(--offset);
      left: var(--offset);
    }

    &.card-1 {
      top: var(--offset);
      right: var(--offset);
    }

    &.card-2 {
      bottom: var(--offset);
      right: var(--offset);
    }

    &.card-3 {
      bottom: var(--offset);
      left: var(--offset);
    }
  }

  .tablet &,
  .mobile & {
    top: 50%;
    left: 50%;
    transform-origin: top left;
    transform: rotate(var(--rotate-offset)) translate(-50%, -50%);
  }

  .mobile & {
    --offset: 15px;

    width: toRem(330);
    height: toRem(330);
    top: 20%;
    left: 50%;
    transform-origin: center;
    transform: rotate(0) translate(-50%, -50%);

    .framework-card {
      transform: rotate(0);
    }
  }
}
</style>
